import React, { useState, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Sidebar from './Sidebar';
import NotificationBell from './NotificationBell';

const AdminLayout = () => {
  const { user, loading } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  // Check if we're on desktop
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);
  
  useEffect(() => {
    const handleResize = () => {
      const desktop = window.innerWidth > 768;
      setIsDesktop(desktop);
      if (!desktop) {
        setSidebarCollapsed(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (loading) return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'var(--admin-bg)' }}>
      <div className="spinner" style={{ width:32, height:32 }} />
    </div>
  );

  if (!user) return <Navigate to="/login" replace />;

  const toggleSidebar = () => {
    if (isDesktop) {
      setSidebarCollapsed(!sidebarCollapsed);
    } else {
      setSidebarOpen(!sidebarOpen);
    }
  };

  return (
    <div className="admin-layout" style={{
      minHeight: '100vh',
      background: '#0a0c10',
      backgroundImage: `
        radial-gradient(circle at 20% 20%, rgba(245, 200, 0, 0.08) 0%, transparent 40%),
        radial-gradient(circle at 80% 80%, rgba(56, 189, 248, 0.06) 0%, transparent 40%),
        radial-gradient(circle at 50% 50%, rgba(15, 23, 42, 0.8) 0%, #0a0c10 100%)
      `,
      backgroundAttachment: 'fixed',
      position: 'relative'
    }}>
      {/* Background Grid Pattern Overlay */}
      <div style={{
        position: 'fixed',
        inset: 0,
        backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px)`,
        backgroundSize: '48px 48px',
        pointerEvents: 'none',
        opacity: 0.6,
        zIndex: 0
      }} />
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} collapsed={sidebarCollapsed} onToggle={toggleSidebar} />
      <div className={`admin-main${sidebarCollapsed ? ' sidebar-collapsed' : ''}`} style={{ position: 'relative', zIndex: 1 }}>
        <header className="admin-topbar">
          <button onClick={() => setSidebarOpen(true)} className="btn btn-secondary btn-sm hamburger-btn" style={{ display:'none' }}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{width:16,height:16}} strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
          </button>
          <div style={{ display:'flex', alignItems:'center', gap:8, marginLeft:'auto' }}>
            <NotificationBell />
          </div>
        </header>
        <main className="admin-content">
          <React.Suspense fallback={
            <div style={{ minHeight: '50vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <div className="spinner" style={{ width: 28, height: 28 }} />
            </div>
          }>
            <Outlet />
          </React.Suspense>
        </main>
      </div>
      <style>{`
        @media(max-width:768px){
          .hamburger-btn{display:flex!important;}
          .sidebar-toggle-btn{display:none!important;}
          .admin-main{margin-left:0;}
        }
        @media(min-width:769px){
          .sidebar-toggle-btn{display:flex!important;}
          .admin-main.sidebar-collapsed{margin-left:72px;}
        }
      `}</style>
    </div>
  );
};

export default AdminLayout;
